/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUrl } from './ApiUrl';
import { ApiUrlFromJSON, ApiUrlFromJSONTyped, ApiUrlToJSON, ApiUrlToJSONTyped } from './ApiUrl';
import type { ApiPipelineVersion } from './ApiPipelineVersion';
import {
  ApiPipelineVersionFromJSON,
  ApiPipelineVersionFromJSONTyped,
  ApiPipelineVersionToJSON,
  ApiPipelineVersionToJSONTyped,
} from './ApiPipelineVersion';
import type { ApiParameter } from './ApiParameter';
import {
  ApiParameterFromJSON,
  ApiParameterFromJSONTyped,
  ApiParameterToJSON,
  ApiParameterToJSONTyped,
} from './ApiParameter';
import type { ApiResourceReference } from './ApiResourceReference';
import {
  ApiResourceReferenceFromJSON,
  ApiResourceReferenceFromJSONTyped,
  ApiResourceReferenceToJSON,
  ApiResourceReferenceToJSONTyped,
} from './ApiResourceReference';

/**
 *
 * @export
 * @interface ApiPipeline
 */
export interface ApiPipeline {
  /**
   * Output. Unique pipeline ID. Generated by API server.
   * @type {string}
   * @memberof ApiPipeline
   */
  id?: string;
  /**
   * Output. The time this pipeline is created.
   * @type {Date}
   * @memberof ApiPipeline
   */
  created_at?: Date;
  /**
   * Optional input field. Pipeline name provided by user. If not specified,
   * file name is used as pipeline name.
   * @type {string}
   * @memberof ApiPipeline
   */
  name?: string;
  /**
   * Optional input field. Describing the purpose of the job.
   * @type {string}
   * @memberof ApiPipeline
   */
  description?: string;
  /**
   * Output. The input parameters for this pipeline.
   * TODO(jingzhang36): replace this parameters field with the parameters field
   * inside PipelineVersion when all usage of the former has been changed to use
   * the latter.
   * @type {Array<ApiParameter>}
   * @memberof ApiPipeline
   */
  parameters?: Array<ApiParameter>;
  /**
   *
   * @type {ApiUrl}
   * @memberof ApiPipeline
   */
  url?: ApiUrl;
  /**
   * In case any error happens retrieving a pipeline field, only pipeline ID
   * and the error message is returned. Client has the flexibility of choosing
   * how to handle error. This is especially useful during listing call.
   * @type {string}
   * @memberof ApiPipeline
   */
  error?: string;
  /**
   *
   * @type {ApiPipelineVersion}
   * @memberof ApiPipeline
   */
  default_version?: ApiPipelineVersion;
  /**
   * Input field. Specify which resource this pipeline belongs to.
   * For Pipeline, the only valid resource reference is a single Namespace.
   * @type {Array<ApiResourceReference>}
   * @memberof ApiPipeline
   */
  resource_references?: Array<ApiResourceReference>;
}

/**
 * Check if a given object implements the ApiPipeline interface.
 */
export function instanceOfApiPipeline(value: object): value is ApiPipeline {
  return true;
}

export function ApiPipelineFromJSON(json: any): ApiPipeline {
  return ApiPipelineFromJSONTyped(json, false);
}

export function ApiPipelineFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPipeline {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    created_at: json['created_at'] == null ? undefined : new Date(json['created_at']),
    name: json['name'] == null ? undefined : json['name'],
    description: json['description'] == null ? undefined : json['description'],
    parameters:
      json['parameters'] == null
        ? undefined
        : (json['parameters'] as Array<any>).map(ApiParameterFromJSON),
    url: json['url'] == null ? undefined : ApiUrlFromJSON(json['url']),
    error: json['error'] == null ? undefined : json['error'],
    default_version:
      json['default_version'] == null
        ? undefined
        : ApiPipelineVersionFromJSON(json['default_version']),
    resource_references:
      json['resource_references'] == null
        ? undefined
        : (json['resource_references'] as Array<any>).map(ApiResourceReferenceFromJSON),
  };
}

export function ApiPipelineToJSON(json: any): ApiPipeline {
  return ApiPipelineToJSONTyped(json, false);
}

export function ApiPipelineToJSONTyped(
  value?: ApiPipeline | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    created_at:
      value['created_at'] == null ? value['created_at'] : value['created_at'].toISOString(),
    name: value['name'],
    description: value['description'],
    parameters:
      value['parameters'] == null
        ? undefined
        : (value['parameters'] as Array<any>).map(ApiParameterToJSON),
    url: ApiUrlToJSON(value['url']),
    error: value['error'],
    default_version: ApiPipelineVersionToJSON(value['default_version']),
    resource_references:
      value['resource_references'] == null
        ? undefined
        : (value['resource_references'] as Array<any>).map(ApiResourceReferenceToJSON),
  };
}
